import React from 'react';

import JerseyColorSelector from './JerseyColorSelector';
import withModal from '../../../../../../../components/global/modal/withModal';

export const JERSEY_COLOR_SELECTOR_MODAL = 'modal/JERSEY_COLOR_SELECTOR';

const JerseyColorSelectorModal = ({ actionProps, ...props }) => {
  const { identityId, albumFolderId } = actionProps ?? {};

  return (
    <JerseyColorSelector
      identityId={identityId}
      albumFolderId={albumFolderId}
      {...props}
    />
  );
};

export default withModal(JerseyColorSelectorModal, {
  name: JERSEY_COLOR_SELECTOR_MODAL,
  size: 'xs',
  type: 'full',
  dismissible: false,
  shouldCloseOnOverlayClick: false,
  hideHeader: true,
});
